import { useTranslation } from "react-i18next";

interface BackgroundInputProps {
  onChange: (imageUrl: string) => void;
}

export default function BackgroundInput({ onChange }: BackgroundInputProps) {
  const { t } = useTranslation();
  return (
    <div>
      <div>{t("Background image")}</div>
      <div>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const files = e.currentTarget.files;
            if (!files || !files.length) {
              return;
            }
            const file = files[0];
            const objectURL = window.URL.createObjectURL(file);
            onChange(objectURL);
            e.currentTarget.value = "";
          }}
        />
      </div>
    </div>
  );
}
